import * as api from '../api';
import {flatten} from '../utils';

const findMatchingNumber = (listOfNumberArrays, number, prefix) => {
  const allNumber = flatten([...Object.values(listOfNumberArrays)]);
  return allNumber
    .filter(it => it.msisdn.toString().includes(number))
    .sort((a, b) => Number(a.prefix === prefix))[0];
};

const switchLanguage = langType => ({
  type: 'SWITCH_LANG',
  payload: langType
});

const setNumbers = numbers => ({
  type: 'SET_NUMBERS',
  payload: numbers
});

const setNotFindAlert = isFinded => ({
  type: 'SET_NOT_FIND_ALERT',
  payload: isFinded
});

const searchResultEmpty = isEmpty => ({
  type: 'SEARCH_RESULT_EMPTY_ALERT',
  payload: isEmpty
});

const failBooking = message => ({
  type: 'BOOKING_NUMBER',
  payload: message
});

export const getNumbers = dispatch => async (number, type, prefix) => {
  try {
    const {data} = await api.getNumbers(number, type, prefix);
    dispatch(searchResultEmpty(false))

    try {
      if (type !== 1) {
        if (!data.response)
          console.log(`На запрос ${prefix} ${number} нет результат`);
        const finded = data.response.find(el => {
          if (prefix) {
            return prefix === el.prefix && el.msisdn.includes(number);
          }
          return el.msisdn.includes(number);
        });

        if (finded) dispatch(setNotFindAlert(false));
        else dispatch(setNotFindAlert(true));
      }
    } catch (err) {

      if (data.response.includes('Empty')) {
        dispatch(searchResultEmpty(true))
        return
      } else {
        dispatch(searchResultEmpty(false))
      }
    }

    const numberList = sortByType(data.response);
    const foundNumber = findMatchingNumber(numberList, number, prefix);
    dispatch(setNumbers(numberList));
    foundNumber && dispatch(selectTab(foundNumber.msisdnType));
  } catch (err) {
    dispatch(setNumbers({}));
  }
};

export const deliveryNumber = dispatch => async (
  city,
  name,
  reservdMsisdn,
  usersMsisdn,
  price
) => {
  try {
    // eslint-disable-next-line no-empty-pattern
    const {} = await api.deliveryNumber(
        city,
        name,
        reservdMsisdn,
        usersMsisdn,
        price
    );
  } catch (err) {
    console.error(err);
  }
};

export const bookingNumber = dispatch => async (
  reservdMsisdn,
  usersMsisdn,
  price
) => {
  try {
    const { data } = await api.bookingNumber(reservdMsisdn, usersMsisdn, price);
    if (data.errors.error && data.errors.error === 'Reserv limit!') {
      dispatch(failBooking('Вы превысили количество броней!'));
    }
  } catch (err) {
    dispatch(failBooking('Что-то пошло не так!'));
  }
};

export const switchLanguageAndSave = dispatch => langType => {
  localStorage.setItem('lang', langType);
  dispatch(switchLanguage(langType));
};

export const selectNumber = number => ({ type: 'SET_SELECTED_NUMBER', number });

export const selectTab = tab => ({ type: 'SET_SELECTED_TAB', tab });

function sortByType(numberList) {
  if (!numberList) return;

  const numberTypes = {};

  const numberListLen = numberList.length;
  for (let i = 0; i < numberListLen; i++) {
    let type = numberList[i].msisdnType;
    if (!numberTypes[type]) numberTypes[type] = [];

    numberTypes[type].push(numberList[i]);
  }
  return numberTypes;
}
